export default __webpack_public_path__ + "static/media/category-selected-bg.b993014c.svg";